import { message } from 'antd';
import React, { useEffect, useState } from 'react'
import EventList from '../../../components/EventList';
import { fetchLiveEvents } from '../../../requests/events';

const LiveEvents = () => {
    const [eventList, setEventList] = useState<any>(null);
    const fetchData = () => {
        fetchLiveEvents().then(response => {
            if(!response || !response.length) {
                message.info("No events are getting streamed now", 1)
            }
            setEventList(response)
        }).catch(err => {
            message.error("Error in fetching live events, Please contact the admin", 2)
        })
    }
    useEffect(() => {
        fetchData()
    }, [])
    return (
        <div>
            <EventList events={eventList} />
        </div>
    )
}

export default LiveEvents;